import {
  FetchDeepArchiveRestoreRequestsFilters,
  FetchDeepArchiveRestoreRequestsSort,
  FetchDeepArchiveRestoreRequestsPage,
  FetchDeepArchiveRestoreRequestsLimit,
  FetchDeepArchiveRestoreRequestsGqlQuery,
  FetchDeepArchiveRestoreRequestsCacheKey
} from '../../deepArchiveRestoreRequestsTypes';

import {
  INITIAL_DEEP_ARCHIVE_RESTORE_REQUESTS_FILTERS,
  INITIAL_DEEP_ARCHIVE_RESTORE_REQUESTS_SORT,
  INITIAL_DEEP_ARCHIVE_RESTORE_REQUESTS_PAGE,
  INITIAL_DEEP_ARCHIVE_RESTORE_REQUESTS_LIMIT
} from '../../deepArchiveRestoreRequestsConstants';

import { useReadIndexQuery } from '../../../common/reactQuery/hooks/useReadIndexQuery';

interface DeepArchiveRestoreRequestsOptions {
  cacheKey: FetchDeepArchiveRestoreRequestsCacheKey;
  query: FetchDeepArchiveRestoreRequestsGqlQuery;
  initialFilters?: FetchDeepArchiveRestoreRequestsFilters;
  initialSort?: FetchDeepArchiveRestoreRequestsSort;
  initialPage?: FetchDeepArchiveRestoreRequestsPage;
  initialLimit?: FetchDeepArchiveRestoreRequestsLimit;
  options?: {
    cacheTime?: number;
    enabled?: boolean;
    enabledPlaceholder?: boolean;
    withoutPrefetch?: boolean;
  };
}

const scope = 'deepArchiveRestoreRequests';

function useDeepArchiveRestoreRequests<ItemType>({
  cacheKey,
  query,
  initialFilters = INITIAL_DEEP_ARCHIVE_RESTORE_REQUESTS_FILTERS,
  initialSort = INITIAL_DEEP_ARCHIVE_RESTORE_REQUESTS_SORT,
  initialPage = INITIAL_DEEP_ARCHIVE_RESTORE_REQUESTS_PAGE,
  initialLimit = INITIAL_DEEP_ARCHIVE_RESTORE_REQUESTS_LIMIT,
  options = {}
}: DeepArchiveRestoreRequestsOptions) {
  const {
    data,
    items,
    itemsError,
    itemsTotalCount,
    isFetched,
    isFetching,
    isLoading,
    isPlaceholderData,
    currentPage,
    currentLimit,
    currentFilters,
    currentSort,
    clearItemsFilters,
    filterItems,
    prefetchItems,
    sortItems,
    paginateItems,
    limitItems
  } = useReadIndexQuery<ItemType>({
    cacheKey,
    initialFilters,
    initialLimit,
    initialPage,
    initialSort,
    options,
    query,
    scope
  });

  return {
    deepArchiveRestoreRequestsData: data,
    deepArchiveRestoreRequests: items,
    deepArchiveRestoreRequestsError: itemsError,
    deepArchiveRestoreRequestsTotalCount: itemsTotalCount,
    deepArchiveRestoreRequestsFetched: isFetched,
    deepArchiveRestoreRequestsFetching: isFetching,
    deepArchiveRestoreRequestsLoading: isLoading,
    deepArchiveRestoreRequestsIsPlaceholderData: isPlaceholderData,
    deepArchiveRestoreRequestsFilters: currentFilters,
    deepArchiveRestoreRequestsSort: currentSort,
    deepArchiveRestoreRequestsPage: currentPage,
    deepArchiveRestoreRequestsLimit: currentLimit,
    filterDeepArchiveRestoreRequests: filterItems,
    clearDeepArchiveRestoreRequestsFilters: clearItemsFilters,
    sortDeepArchiveRestoreRequests: sortItems,
    paginateDeepArchiveRestoreRequests: paginateItems,
    limitDeepArchiveRestoreRequests: limitItems,
    prefetchDeepArchiveRestoreRequests: prefetchItems
  };
}

export default useDeepArchiveRestoreRequests;
